import { Input } from '@/components/ui/input';

interface Props {
  value: string;
  onChange: (v: string) => void;
}

export function QualifyStepProducerName({ value, onChange }: Props) {
  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <h2 className="font-display text-xl text-foreground">Vad heter din verksamhet?</h2>
        <p className="text-sm text-muted-foreground">
          Det här är ditt namn som värd, inte platsens namn.
        </p>
      </div>
      <div>
        <Input
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="t.ex. Gretas stuga, Mor Linas Getgård, Siljanslax"
          autoFocus
        />
        <p className="text-xs text-muted-foreground/60 mt-2">
          Du kan ändra detta senare.
        </p>
      </div>
    </div>
  );
}
